import { CnDialog } from '@cainiaofe/cn-ui';
import { calculateTextExprValue, getRealResponse } from '../util/util';
import { getConeEnv } from '../util/const';
import { queryData } from '@/lowcode/common/service';
import { BaseLowCodeProps, RequestConfig } from '@/lowcode/common/types';
import { shakeObj } from '@/utils';
import {
  getRealRequestUrl,
  transRequestConfigToRemote,
  handleResultProcessFunc2,
  isDataEasyDataSource,
  getDesignRequestConfig,
  getFilterValue,
} from './requestUtil';

// 运行时请求数据
export function makeRequest<TData = unknown>(config: RequestConfig): Promise<{ data: TData }> {
  const { needSuccessToast = true } = config;
  const {
    handleParams,
    buttonConfig,
    state,
    recordDataSource,
    urlParamsDataSource,
    onCancel,
    extraParamList,
    isDesign,
    noNeedHandleResult,
    getExtraParam,
    handleParamsBeforeSend,
  } = config;
  return new Promise((resolve, reject) => {
    if (buttonConfig) {
      const { requestConfig, needConfirm, confirmInfo = {} } = buttonConfig?.options || {};

      const sendRequest = async () => {
        const realUrl = getRealRequestUrl({
          requestConfig,
          state,
          extraParam: getExtraParam?.(),
        });
        if (!realUrl) {
          reject();
        }

        const res = await queryData(
          transRequestConfigToRemote({
            requestConfig,
            handleParams,
            state,
            urlParamsDataSource,
            recordDataSource,
            isDesign,
            extraParamList,
            getExtraParam,
            handleParamsBeforeSend,
          }),
          (resp) => {
            if (noNeedHandleResult) {
              return getRealResponse(resp);
            }
            return handleResultProcessFunc2(resp, requestConfig, {
              state,
            });
          },
          needSuccessToast,
        );
        if (res) {
          resolve(res);
          return;
        }
        reject();
      };

      if (needConfirm) {
        const title = calculateTextExprValue(confirmInfo.title, {
          urlParamsDataSource,
          recordDataSource,
          state,
          extraParamList,
        });
        const content = calculateTextExprValue(confirmInfo.content, {
          urlParamsDataSource,
          recordDataSource,
          state,
          extraParamList,
        });

        CnDialog.confirm({
          title: title || '通知',
          content: content || '',
          messageProps: {
            className: 'l2-dialog-message-content',
          },
          onOk: () => {
            sendRequest();
          },
          onCancel: () => {
            onCancel && onCancel();
          },
          onClose: () => {
            onCancel && onCancel();
          },
        });
      } else {
        sendRequest();
      }
    }
  });
}

export function makeChartRequestConfig(config: BaseLowCodeProps): RequestConfig {
  const {
    filterConfig,
    _context,
    dataFrom,
    isDesign,
    sorts,
    aggregationConfig,
    currentPage,
    pageSize,
  } = config || {};

  const originalRequestConfig = dataFrom?.requestConfig || {};

  // TODO: 这段逻辑应当抽离到低码组件view中
  const requestConfig = isDesign
    ? getDesignRequestConfig(originalRequestConfig)
    : originalRequestConfig;

  const { serviceType, guid, serviceCode } = requestConfig;
  const filterValue = getFilterValue({
    filterConfig,
    _context,
  });

  const realRequestConfig: RequestConfig = {
    isDesign,
    needSuccessToast: false, // 请求成功后是否toast提示
    buttonConfig: {
      options: {
        requestConfig,
      },
    },
    recordDataSource: {},
    state: _context?.state || {},
  };

  const realUrl = getRealRequestUrl({
    requestConfig,
    state: _context?.state,
  });

  if (isDataEasyDataSource(serviceType, realUrl)) {
    return {
      ...realRequestConfig,
      buttonConfig: {
        options: {
          requestConfig: {
            ...requestConfig,
            method: 'post',
            serviceType: 'http',
          },
        },
      },
      handleParamsBeforeSend: (data = {}) => {
        const params = shakeObj({
          params: {
            ...filterValue,
            ...data,
          },
          currentPage: currentPage || data.currentPage,
          pageSize: pageSize || data.pageSize,
          serviceCode: serviceCode || guid,
          env: isDesign ? getConeEnv() : undefined,
          sorts,
          config: aggregationConfig,
        });

        return params;
      },
    };
  }

  return {
    ...realRequestConfig,
    handleParams: (data = {}) => {
      return {
        ...data,
        ...filterValue,
        ...(sorts ? { sorts } : null),
        ...(sorts && sorts.length > 0
          ? { sortsJson: encodeURIComponent(JSON.stringify(sorts)) }
          : null),
      };
    },
  };
}
